import * as t from 'io-ts';

import {makeApiType, RLazyTeammateIdRef} from './apiTypes';

/*
 * Runtime type.
 */

export const RDraftSeed = t.readonly(
  t.type({
    uid: t.string,
    authorId: RLazyTeammateIdRef,
    updatedAt: t.Integer,
  }),
);

/*
 * Type.
 */

export interface DraftSeedModel extends t.TypeOf<typeof RDraftSeed> {}

/*
 * IO methods.
 */

export function parseDraftSeed(src: any): DraftSeedModel {
  return {
    uid: src.uid || String(src.id),
    authorId: src.author_id,
    updatedAt: src.updated_at,
  };
}

/*
 * API type.
 */

export const ApiDraftSeed = makeApiType('draftSeed', RDraftSeed, parseDraftSeed);
